import React from "react";
import Collapsible from 'react-collapsible';
import ImgixFluidImage from "../../newComponents/ImgixFluidImage";

const AgywAccordions = ({ block }) => {


  const finalImage1 = block.columnImages[0] ? <ImgixFluidImage attribution={block.columnImages[0].attribution} image={block.columnImages[0]} sizes="25vw" width={236} height={248} focalPoint={block.columnImages[0].focalPoint}/>  : null;

  const finalImage2 = block.columnImages[1] ? <ImgixFluidImage attribution={block.columnImages[1].attribution} image={block.columnImages[1]} sizes="25vw" width={250} height={250} focalPoint={block.columnImages[1].focalPoint}/>  : null;

  const finalImage3 = block.columnImages[2] ? <ImgixFluidImage attribution={block.columnImages[2].attribution} image={block.columnImages[2]} sizes="25vw" width={251} height={248} focalPoint={block.columnImages[2].focalPoint}/>  : null;


  return (
    <section>
      <div className="shell mb-4">
        <div className="grid grid-cols-1 md:grid-cols-3">
          <div className="accordion-column-1 p-4 mb-4">
            <div className="flex justify-center p-4">
              <div className="w-6/12">{finalImage1}</div>
            </div>
            <p className="accordion-heading-1 font-bold text-lg text-center mb-4">{ block.columnOneHeading }</p>
            {block.colunmOneQuestionOne && block.columnOneTextOne && 
              <Collapsible trigger={block.colunmOneQuestionOne}>
                <div dangerouslySetInnerHTML={{ __html: block.columnOneTextOne, }}/>
              </Collapsible>
            }
            {block.colunmOneQuestionTwo && block.colunmOneTextTwo &&
              <Collapsible trigger={block.colunmOneQuestionTwo}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmOneTextTwo, }}/>
              </Collapsible>
            }
            {block.colunmOneQuestionThree && block.colunmOneTextThree &&
              <Collapsible trigger={block.colunmOneQuestionThree}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmOneTextThree, }}/>
              </Collapsible>
            }
          </div>
          <div className="accordion-column-2 p-4 mb-4">
            <div className="flex justify-center p-4">
              <div className="w-6/12">{finalImage2}</div>
            </div>
            <p className="accordion-heading-2 font-bold text-lg text-center mb-4">{ block.columnTwoHeading }</p>
            {block.colunmTwoQuestionOne && block.colunmTwoTextOne &&
              <Collapsible trigger={block.colunmTwoQuestionOne}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmTwoTextOne, }}/>
              </Collapsible>
            }
            {block.colunmTwoQuestionTwo && block.colunmTwoTextTwo &&
              <Collapsible trigger={block.colunmTwoQuestionTwo}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmTwoTextTwo, }}/>
              </Collapsible>
            }
            {block.colunmTwoQuestionThree && block.colunmTwoTextThree &&
              <Collapsible trigger={block.colunmTwoQuestionThree}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmTwoTextThree, }}/>
              </Collapsible>
            }
          </div>
          <div className="accordion-column-3 p-4 mb-4">
            <div className="flex justify-center p-4">
              <div className="w-6/12">{finalImage3}</div>
            </div>
            <p className="accordion-heading-3 font-bold text-lg text-center mb-4">{ block.columnThreeHeading }</p>
            {block.colunmThreeQuestionOne && block.colunmThreeTextOne && 
              <Collapsible trigger={block.colunmThreeQuestionOne}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmThreeTextOne, }}/>
              </Collapsible>
            }
            {block.colunmThreeQuestionTwo && block.colunmThreeTextTwo && 
              <Collapsible trigger={block.colunmThreeQuestionTwo}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmThreeTextTwo, }}/>
              </Collapsible>
            }
            {block.colunmThreeQuestionThree && block.colunmThreeTextThree && 
              <Collapsible trigger={block.colunmThreeQuestionThree}>
                <div dangerouslySetInnerHTML={{ __html: block.colunmThreeTextThree, }}/>
              </Collapsible>
            }

          </div>
        </div>
      </div>
    </section>
  );
}

export default AgywAccordions; 
